import { useCallback, useState } from "react";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { Box, Button, Typography } from "@mui/material";
import { DialogComponent } from "src/utils/GlobalModal/DialogComponent";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import { useSelectedRows } from "src/Pages/Company/Pending/PendingBenefits/SelectedRowsProvider/hooks";
import { useMassDecline } from "src/Pages/Company/Pending/PendingBenefits/query";

export const MassActionDecline = () => {
  const [open, setOpen] = useState(false);
  const {
    getMassActionData,
    resetSelection,
    selectedSalaryDeductionsCount,
    selectedCancellableWaitingRoomsCount,
  } = useSelectedRows();

  const toDeclineCount =
    selectedSalaryDeductionsCount + selectedCancellableWaitingRoomsCount;

  const { isPending, mutate } = useMassDecline();

  const confirm = useCallback(() => {
    mutate(getMassActionData(), {
      onSuccess: () => {
        resetSelection();
        dynamicNotification(__("Pomyślnie odrzucono"));
      },
      onError: () => {
        dynamicNotification(__("Nie udało się odrzucić"), "error");
      },
      onSettled: () => {
        setOpen(false);
      },
    });
  }, [getMassActionData, mutate, resetSelection]);

  return (
    <>
      <Button
        color="error"
        size="small"
        variant="outlined"
        startIcon={<CancelOutlinedIcon />}
        disabled={toDeclineCount === 0}
        onClick={() => setOpen(true)}
      >
        {__("Odrzuć zaznaczone")} {toDeclineCount > 0 ? toDeclineCount : ""}
      </Button>
      <DialogComponent
        isOpen={open}
        onClose={() => setOpen(false)}
        title={__("Odrzuć zaznaczone")}
        description={__("Te zmiany sa nieodwracalne")}
        actions={({ close }) => (
          <>
            <Button
              variant="outlined"
              color="inherit"
              disabled={isPending}
              onClick={close}
            >
              {__("Anuluj")}
            </Button>
            <Button
              variant="contained"
              color="error"
              loading={isPending}
              loadingPosition="start"
              onClick={confirm}
            >
              {__("Odrzuć")}
            </Button>
          </>
        )}
      >
        <Box sx={{ mb: 2 }}>
          {selectedSalaryDeductionsCount > 0 && (
            <Box sx={{ mb: 1 }}>
              <Typography variant="body1">
                {__("Liczba odrzucanych zgód na potrącenie: {0}", [
                  selectedSalaryDeductionsCount,
                ])}
              </Typography>
            </Box>
          )}
          {selectedCancellableWaitingRoomsCount > 0 && (
            <Box sx={{ mb: 1 }}>
              <Typography variant="body1">
                {__("Liczba odrzucanych zamówień: {0}", [
                  selectedCancellableWaitingRoomsCount,
                ])}
              </Typography>
            </Box>
          )}
        </Box>
      </DialogComponent>
    </>
  );
};
